import { t } from "@travily/i18n";
import { accountSettingsNotificationsPath, accountSettingsProfilePath } from "@travily/routes";
import { Icon } from "@ui/components/Icon";
import type { EditorNavSection } from "@/components/EditorSectionNav/EditorSectionNav";

/**
 * The account-settings section registry — the one place a new section is
 * added. Unlike the listing editor's, these sections are static (fixed paths,
 * no per-entity previews), so the whole registry lives client-side.
 */
export function settingsSections(): EditorNavSection[] {
  return [
    {
      key: "profile",
      label: t("web.accounts.settings.sections.profile"),
      href: accountSettingsProfilePath(),
      icon: <Icon name="profile" size="24" type="sticker" />,
    },
    {
      key: "notifications",
      label: t("web.accounts.settings.sections.notifications"),
      href: accountSettingsNotificationsPath(),
      icon: <Icon name="bell" size="24" type="sticker" />,
    },
  ];
}
